<template>
  <div class="m_index productlist" :style={minHeight:minh}>
    <div class="index_banner">  
      <div class="product_head">
        <img src="/static/images/m/back.png" alt="" class="p_back" @click='back'>
        <p class="p_head_name">{{cate.name}}</p>
      </div>
      <div class="m_index p">
        <div class="product_wrap clearfix">
          <div class="product_item" v-for='item in list'>
            <router-link :to="'/m/product/detail/'+item.id">
              <img src="/static/images/m/new.png" alt="" class="icons_new" v-if='item.flag==1'>
              <img src="/static/images/m/hot.png" alt="" class="icons_hot" v-if='item.flag==2'>
              <div class="p_img_wrap">
                <img :src="domain+item.litpic" alt="">
              </div>
              <div class="p_name">
                <p class="p_name_c">{{item.title}}</p>
                <p>{{item.model}}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      cate:'',
      list:[],
      minh:''
    }
  },
  watch:{
    '$route':function(to,from){
      this.getList()
    }
  },
  mounted:function(){
    this.domain=this._routerRoot.domain
    this.getList()
    this.minh = document.documentElement.clientHeight-100+'px';
  },
  methods:{
    back(){
       window.history.back() 
    },
    getList:function(){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_product_lists', this.$qs.stringify({
        cid:this.$route.params.ids,
        page:1,
        limit:1000
      }))
      .then(response => {
        console.log(response);
        this.list=response.data.data
        this.cate = response.data.cate
        //this.getparent(this.cate.id)
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      })
      .catch(error => {
        console.log(error);
      });
    },
  }
}
</script>

<style scoped>
  .m_common_title{
    font-size: 0.2rem;
    color: #383838;
    text-align: center;
    padding: 0.5rem 0;
  }
  .m_common_title:before{
    content: '';
    display: inline-block;
    width: 0.22rem;
    height: 1px;
    background-color: #7e7e7e;
    position: relative;
    right: 0.05rem;
    top: -0.05rem;
  }
  .m_common_title:after{
    content: '';
    display: inline-block;
    width: 0.22rem;
    height: 1px;
    background-color: #7e7e7e;
    position: relative;
    left: 0.05rem;
    top: -0.05rem;
  }
  .index_banner img{
    display: block;
  }
  .itemList{
    padding: 0 0.2rem;
  }
  .itemList .item{
    width: 25%;
    float: left;
    text-align: center;
    margin-bottom: 0.7rem;
  }
  .itemList .item img{
    height: 0.55rem;
    display: block;
    margin: 0 auto;
    margin-bottom: 0.24rem;
  }
  .item_name{
    font-size: 0.18rem;
    color: #383838;
  }
  .morebtn{
    font-size: 0.18rem;
    color: #383838;
    float: right;
    margin-right: 0.6rem;
    padding-right: 0.2rem;
    background-image: url(/static/images/m/arrow_r.png);
    background-size: 0.13rem 0.14rem;
    background-position: right center;
    background-repeat: no-repeat;
    margin-top: -0.4rem;
  }
  .active_banner{
    display: block;
    width: 100%;
  }
  .product_wrap{
    padding: 0 0.2rem;
  }
  .product_item{
    width: 2.9rem;
    float: left;
    margin-right: 0.2rem;
    background-color: #fff;
    margin-bottom: 0.2rem;
    text-align: center;
    position: relative;
  }
  .product_item:nth-child(2n){
    margin-right: 0;
  }
  .m_index.p{
    background-color: #f8f7f7;
  }
    .p_img_wrap{
    height: 2.9rem;
    margin-bottom: 0.4rem;
    position: relative;
    width: 2.9rem;
  }
  .p_img_wrap img{
    width: 100%;
    max-height: 100%;
    display: block;
    margin: 0 auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .p_name{
    font-size: 0.24rem;
    color: #5d5d5d;
    text-align: left;
    padding-left: 0.24rem;
    box-sizing: border-box;
    padding-bottom: 0.3rem;
    line-height: 150%;
  }
  .icons_new{
    position: absolute;
    width: 0.7rem;
    top: 0.22rem;
    left: 0.14rem;
    z-index: 999;
  }
  .icons_hot{
    position: absolute;
    width: 0.59rem;
    top: 0.22rem;
    left: 0.14rem;
    z-index: 999;
  }
  .product_head{
    height: 0.99rem;
    line-height: 0.99rem;
    text-align: center;
    background-color: #f9f9f9;
    position: relative;
    border-bottom: 1px solid #e0e0e0;
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 999;
  }
  .p_head_name{
    font-size: 0.24rem;
    color: #383838;
  }
  .p_head_name:before{
    content: '';
    display: inline-block;
    width: 0.24rem;
    height: 1px;
    background-color: #383838;
    position:relative;
    top: -0.07rem;
    right: 0.07rem;
  }
  .p_head_name:after{
    content: '';
    display: inline-block;
    width: 0.24rem;
    height: 1px;
    background-color: #383838;
    position:relative;
    top: -0.07rem;
    left: 0.07rem;
  }
  .p_back{
    width: 0.13rem;
    position: absolute;
    left: 0.32rem;
    top: 0.37rem;
  }
  .productlist{
    padding-top: 1.2rem;
    background-color: #f8f7f7
  }
</style>


// WEBPACK FOOTER //
// src/components/mobile/product_list.vue